// extracted by mini-css-extract-plugin
export default {"error":"Alert_error__s9Ssc","noti":"Alert_noti__KARg+","excla":"Alert_excla__U8gfN"};